import { Modal, ModalProps, Select } from 'antd'
import VSpace from '../common/VSpace'
import { ItemWorkareaData } from './itemModel'
import { useEffect, useRef, useState } from 'react'

export type Props = {
  open: boolean
  workareas: ItemWorkareaData[]
  onSelect: (workareaId: number) => void
  onCancel: () => void
} & Pick<ModalProps, 'getContainer'>

const WorkareaSelectionModal = ({ open, workareas, onSelect, onCancel, getContainer }: Props) => {
  const [selectedWorkareaId, setSelectedWorkareaId] = useState<number | undefined>()
  const selectRef = useRef<any>()

  useEffect(() => {
    setTimeout(() => selectRef.current?.focus(), 1)
  }, [open])

  return <Modal
    title="Select Workarea"
    open={open}
    okText="Add Item"
    okButtonProps={{
      disabled: selectedWorkareaId === undefined
    }}
    onOk={() => onSelect(selectedWorkareaId!)}
    onCancel={onCancel}
    getContainer={getContainer}
  >
    <VSpace>
      <label>Which workarea should this item be added to?</label>
      <Select
        placeholder="Select workarea..."
        options={workareas.filter(x => !x.isOnHold).map(x => ({ label: x.name, value: x.id }))}
        style={{ width: '100%' }}
        onChange={setSelectedWorkareaId}
        ref={selectRef}
      />
    </VSpace>
  </Modal>
}

export default WorkareaSelectionModal
